export default __webpack_public_path__ + "img/c35257f9f2a4bd24022245a93d249078.png";